import { VariationSelectedType, PatternReplacement } from "constants/dataTypes";


export function convertFormatWithRegex(inputArray: VariationSelectedType[], patternReplacements: PatternReplacement[]): VariationSelectedType[] {
    // Function to convert a single string based on multiple pattern-replacement pairs
    function convertString(s: VariationSelectedType): VariationSelectedType {
        
        // Return the original string if it's empty
        if(!s.value) return s;
        
        for (const pr of patternReplacements) {
            const match = s.value.match(pr.pattern);
            if (match) {
                let replaced = s.value.replace(pr.pattern, pr.replacement);
                const value = parseFloat(replaced);
                if (pr.addPositiveSign && value > 0) {
                    replaced = `+${replaced}`;
                }
                s.value = replaced;
                return s;
            }
        }
        return s; // Return the original string if it doesn't match any pattern
    }

    // Apply the convertString function to each element in the input array
    return inputArray.map(convertString);
}
